import { render, staticRenderFns } from "./AssemblyOption.vue?vue&type=template&id=6144a452"
import script from "./AssemblyOption.vue?vue&type=script&lang=js"
export * from "./AssemblyOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports